
import { SEO } from '../../utils/seo';
import Header from './components/Header';
import Hero from './components/Hero';
import Why from './components/Why';
import Symptoms from './components/Symptoms';
import Features from './components/Features';
import Deliverables from './components/Deliverables';
import Process from './components/Process';
import Proof from './components/Proof';
import Pricing from './components/Pricing';
import Opinion from './components/Opinion';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import Footer from './components/Footer';

export default function Autopilot() {
  const schema = {
    '@type': 'Service',
    name: 'Autopilot by SuperSpoon',
    description:
      '問い合わせが来ないサイトを"問い合わせが来る構造"に変える。BtoBサイト改善と広告運用の最適化サービス。',
    provider: {
      '@type': 'Organization',
      name: 'SuperSpoon',
    },
    areaServed: 'JP',
    serviceType: ['サイト改善', '広告運用', 'LP最適化', 'BtoBマーケティング'],
  };

  return (
    <div className="min-h-screen bg-white">
      {/* 
        Use single quotes for the JSX attribute value so the internal double‑quotes 
        in the Japanese text are treated as literal characters and do not terminate 
        the string early. This prevents the “Expected '>' but found ...” syntax error.
      */}
      <SEO
        title='Autopilot｜問い合わせが来ないサイトを"問い合わせが来る構造"に変える'
        description="BtoB / サイト改善 × 広告運用。広告を回す前に、LPと導線を最適化。少額広告で検証し、数字で改善を積み上げます。無料10分診断で原因を特定。"
        keywords="BtoBマーケティング,サイト改善,LP最適化,広告運用,問い合わせ増加,CVR改善"
        path="/autopilot"
        schema={schema}
      />
      <Header />
      <main>
        <Hero />
        <Why />
        <Symptoms />
        <Features />
        <Deliverables />
        <Process />
        <Proof />
        <Pricing />
        <Opinion />
        <FAQ />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}
